import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'

// Fetch

const fetchReportCustomerMonthlyPlansEpic = (action$, store) => {
    return action$.ofType(actionTypes.FETCH).switchMap(action =>
        Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-customer-monthly-plans`,
                body: {
                    settings: store.getState().reportCustomerMonthlyPlans.getIn(['list', 'settings']),
                    year: store.getState().reportCustomerMonthlyPlans.getIn(['list', 'year']),
                },
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCustomerMonthlyPlansFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportCustomerMonthlyPlansRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
        )
    )
}

// Export

const exportReportCustomerMonthlyPlansEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const settings = JSON.stringify(store.getState().reportCustomerMonthlyPlans.getIn(['list', 'settings']))
        const year = store.getState().reportCustomerMonthlyPlans.getIn(['list', 'year'])
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-customer-monthly-plans/export?year=${year}&settings=${settings}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })

export default [fetchReportCustomerMonthlyPlansEpic, exportReportCustomerMonthlyPlansEpic]
